import React from "react";
import sample from "../assets/sampleimage.png";
import Instagram from "../components/Instagram";
import Lottie from "lottie-react";
import aboutAnimation from "../assets/about.json";
import shopping from "../assets/shopping.json";
const About = () => {
  return (
    <div>
      <div className="mb-4">
        <img
          src={sample}
          alt="Privacy Policy Banner"
          className="img-fluid w-100"
        />
      </div>

      <div className="container">
        <Instagram />
      </div>

      <div className="d-flex flex-wrap p-0 p-md-5 align-items-center">
        <div className="col-12 col-md-6 p-2">
          <Lottie
            animationData={aboutAnimation}
            loop={true}
            className="w-100"
          />
        </div>
        <div className="col-12 col-md-6 p-2 d-flex align-items-center">
          <p className="section-text">
            What makes BSK Boutique truly special is the heart behind every
            product. Built from the ground up with honesty, quality, and
            customer trust, the brand has earned a reputation that speaks for
            itself. Their handcrafted items have reached thousands of homes,
            creating smiles and long-lasting satisfaction. With their impressive
            social presence and consistent quality over seven years, BSK
            Boutique remains committed to delivering the very best. Their
            journey is a reminder that passion, hard work, and genuine care can
            create something meaningful—a brand that people love, trust, and
            proudly support every day. Beyond just products, BSK Boutique is
            about creating experiences, celebrating creativity, and making every
            customer feel valued and connected.
          </p>
        </div>

        <div className="col-12 col-md-6 p-2 d-flex align-items-center order-md-1 order-4">
          <p className="section-text">
            BSK Boutique not only delivers premium handmade products but also
            provides a seamless online shopping experience for every customer.
            With fast and secure payment options, customers can shop with
            complete confidence from anywhere, anytime. Their website and
            Instagram store are designed for smooth, hassle-free purchasing,
            making it easier than ever to get your favorite products delivered
            right to your doorstep. With dedicated 24/7 customer support, BSK
            Boutique ensures that every buyer feels valued and cared for at
            every step. Their commitment to trust, safety, and convenience has
            helped them build a strong, loyal community that continues to grow
            every day. Every order is handled with precision, ensuring timely
            delivery, careful packaging, and a delightful unboxing experience
            that keeps customers coming back.
          </p>
        </div>
        <div className="col-12 col-md-6 p-2 order-md-2 order-3">
          <Lottie
            animationData={shopping}
            loop={true}
            className="w-100"
          />
        </div>
      </div>
      <div className="container mb-4">
        <div className="card shadow-lg border-0 p-3">
          <h3 className="mb-3 fw-bold text-center">
            Frequently Asked Questions
          </h3>

          <div className="accordion" id="faqAccordion">
            {/* Q1 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                >
                  1. What is your return policy?
                </button>
              </h2>

              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  We offer a 7-day return policy for unused items in original
                  condition.
                </div>
              </div>
            </div>

            {/* Q2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  2. Do you provide free shipping?
                </button>
              </h2>

              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, free shipping is available for all prepaid orders above
                  ₹499.
                </div>
              </div>
            </div>

            {/* Q3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                >
                  3. How can I track my order?
                </button>
              </h2>

              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  You will receive a tracking link via SMS & Email once your
                  order ships.
                </div>
              </div>
            </div>

            {/* Q4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                >
                  4. Can I modify my order after placing it?
                </button>
              </h2>

              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Orders can be modified within 2 hours of placing them.
                </div>
              </div>
            </div>

            {/* Q5 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                >
                  5. Do you offer cash on delivery (COD)?
                </button>
              </h2>

              <div
                id="collapseFive"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes, COD is available for selected locations.
                </div>
              </div>
            </div>

            {/* Q6 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSix">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                >
                  6. How do I contact customer support?
                </button>
              </h2>

              <div
                id="collapseSix"
                className="accordion-collapse collapse"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  You can reach us via email or our Contact Us page 24/7.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
